import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import CkEditor from 'src/components/editor'
import { useSelector, useDispatch } from 'react-redux'
import { useCourseSettings } from 'src/hooks/useCourseSettings'
import { editorLoading } from 'src/reducers/card/action'
import { useLocation } from 'react-router-dom'
import { useParams } from 'react-router-dom/cjs/react-router-dom'

const DragDropEditor = props => {
  const { classes } = props
  const [isReady, setIsReady] = useState(false)
  const course = useSelector(state => state.course.course)
  const { execute, update, exists, value } = useCourseSettings('general')
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const { page, subPage } = useParams()
  const editorLoadingState = useSelector(state => state.card.editorLoading)
  const { collection } = useSelector(state => state)
  const landingPageSettings = useSelector(
    state => state.course.landingPageSettings,
  )
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )

  const pageUrl = window.location.pathname.split('/')[1]
  const landingPageData =
    pageUrl === 'mini-course' ? landingPageSettings : collectionSettings

  // Only use courseId for the key, not the content
  const editorKey = `${course?.id || 'loading'}`

  // Track when data is ready based on URL path
  useEffect(() => {
    if (pageUrl === 'mini-course' && landingPageSettings) {
      setIsReady(true)
    } else if (pageUrl !== 'mini-course' && collectionSettings) {
      setIsReady(true)
    }
  }, [pageUrl, landingPageSettings, collectionSettings])

  // Track content initialization with useEffect
  useEffect(() => {
    // Reset loading state when course changes
    if (editorLoadingState) {
      dispatch(editorLoading())
    }
  }, [course?.id, dispatch, editorLoadingState])

  const handleSaveCourseSettings = newDescription => {
    if (!editorLoadingState) {
      dispatch(editorLoading())
    }

    // Only proceed if value exists
    if (!value) return

    const variables = {
      ...value,
      coverPageText: newDescription,
    }

    const callback = () =>
      setTimeout(() => {
        dispatch(editorLoading())
      }, 2000)

    if (!exists) {
      execute(variables, callback)
    } else {
      update(variables, callback)
    }
  }

  const themeSettingsStringified = course?.settingDtos?.find(
    setting => setting.key === 'theme',
  )
  const themeSettings = themeSettingsStringified
    ? JSON.parse(themeSettingsStringified?.value)
    : null

  const fontSize = 'M'
  const font = landingPageData?.font

  // Determine if the editor should render
  const shouldRenderEditor = () => {
    if (pageUrl === 'mini-course') {
      return course && value && subPage === 'editor' && isReady
    } else {
      return collection && subPage === 'editor' && isReady
    }
  }

  // Get the initial data safely with null checks
  const getInitialData = () => {
    try {
      var landingPageSection = landingPageData?.sections.find(
        x => x.type === 'Main',
      )
      if (landingPageData && landingPageData.sections && landingPageSection) {
        return landingPageSection.content.html
      }
      return ''
    } catch (error) {
      console.error('Error getting initial data:', error)
      return ''
    }
  }

  return (
    <CkEditor
      key={editorKey}
      initialData={getInitialData()}
      saveData={handleSaveCourseSettings}
      fontSize={fontSize}
      fontFamily={font}
      page={page}
      landingPageData={landingPageData} // Pass the entire landingPageData to CkEditor
    />
  )
}

export default withStyles(styles)(DragDropEditor)
